export const playSound = (mode, src) =>{
    if (mode !== '0') return;
    const audio = new Audio();
    audio.preload = 'auto';
    audio.src = src;
    audio.play();
}